<template>
  <div>
    <Navbar></Navbar>
    <div class="container mt-3 mt-lg-5">
      <!-- TITLE-->
      <div class="row mb-3">
        <div class="col-md-12">
          <vue-aos animation-class="animate__animated animate__flipInX">
            <h1 class="fw-500 typography-headline-lg">Palettes</h1>
          </vue-aos>
        </div>
      </div>

      <!-- SEARCH COLORS SHORTCUTS -->
      <div class="scrolling-wrapper d-flex flex-row flex-nowrap">
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Red' ? 'btn-primary' : '']" @click="changeKeyword('Red')">
            <i class="material-icons mdc-18 me-2" style="color: red">&#xe061;</i>
            Red
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Blue' ? 'btn-primary' : '']" @click="changeKeyword('Blue')">
            <i class="material-icons mdc-18 me-2" style="color: blue">&#xe061;</i>
            Blue
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Green' ? 'btn-primary' : '']" @click="changeKeyword('Green')">
            <i class="material-icons mdc-18 me-2" style="color: green">&#xe061;</i>
            Green
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Cyan' ? 'btn-primary' : '']" @click="changeKeyword('Cyan')">
            <i class="material-icons mdc-18 me-2" style="color: cyan">&#xe061;</i>
            Cyan
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Pink' ? 'btn-primary' : '']" @click="changeKeyword('Pink')">
            <i class="material-icons mdc-18 me-2" style="color: pink">&#xe061;</i>
            Pink
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Yellow' ? 'btn-primary' : '']" @click="changeKeyword('Yellow')">
            <i class="material-icons mdc-18 me-2" style="color: yellow">&#xe061;</i>
            Yellow
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Black' ? 'btn-primary' : '']" @click="changeKeyword('Black')">
            <i class="material-icons mdc-18 me-2" style="color: black">&#xe061;</i>
            Black
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'White' ? 'btn-primary' : '']" @click="changeKeyword('White')">
            <i class="material-icons mdc-18 me-2" style="color: antiquewhite">&#xe061;</i>
            White
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Grey' ? 'btn-primary' : '']" @click="changeKeyword('Grey')">
            <i class="material-icons mdc-18 me-2" style="color: grey">&#xe061;</i>
            Grey
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Orange' ? 'btn-primary' : '']" @click="changeKeyword('Orange')">
            <i class="material-icons mdc-18 me-2" style="color: orange">&#xe061;</i>
            Orange
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Purple' ? 'btn-primary' : '']" @click="changeKeyword('Purple')">
            <i class="material-icons mdc-18 me-2" style="color: purple">&#xe061;</i>
            Purple
          </button>
        </div>
        <div>
          <button class="btn btn-default-outline is-filter btn-round ripple ripple-primary px-3"
                  :class="[ keywordValue === 'Brown' ? 'btn-primary' : '']" @click="changeKeyword('Brown')">
            <i class="material-icons mdc-18 me-2" style="color: brown">&#xe061;</i>
            Brown
          </button>
        </div>
      </div>

      <!-- NEW PALETTES SECTION -->
      <div v-if="!palettes || (palettes && palettes.length < 1)" class="col-md-12 text-center mt-3">
        <LoadingState title="Loading palettes..."
                      subtitle="If nothing loads, please check if Javascript is enabled in your browser or our services are probably not available in your country, so try using a VPN"></LoadingState>
      </div>
      <PalettesList :palettes="palettes"></PalettesList>

      <!-- PAGINATION SECTION -->
      <div class="row mb-3">
        <div class="col-md-12 text-center mb-3">
          <button class="btn btn-primary btn-round btn-micint-rotate ripple ripple-dark py-3 px-5"
                  @click="loadMorePalettes">Load more
            palettes
            <i class="material-icons-outlined ms-2">&#xe86a;</i>
          </button>
        </div>
      </div>

    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navbar from "@/components/includes/Navbar";
import Footer from "@/components/includes/Footer";
import firebase from 'firebase/app'
import 'firebase/firestore'
import PalettesList from "@/components/palettes/PalettesList";
import VueAos from 'vue-aos'
import {mapGetters} from "vuex";
import LoadingState from "@/components/empty-states/LoadingState";

export default {
  name: 'Palettes',
  metaInfo: {
    title: 'Palettes',
  },
  components: {PalettesList, Footer, Navbar, VueAos, LoadingState},
  data() {
    return {
      palettes: [],
      db: firebase.firestore(),
      keywordValue: '',
      lastPalette: null,
      disabledButton: false
    }
  },
  mounted() {
    this.fetchPalettes()
  },
  methods: {
    async fetchPalettes() {

      let palettesSnap = this.db
          .collection('palettes')

      if (this.keywordValue) {
        palettesSnap = palettesSnap
            .where('colorKeywords', 'array-contains', this.keywordValue)
      }

      palettesSnap = await palettesSnap
          .orderBy('createdAt', "desc")
          .limit(12)
          .get()

      this.lastPalette = palettesSnap.docs[palettesSnap.docs.length - 1]

      this.palettes = palettesSnap.docs.map(doc => {
        return {id: doc.id, isLiked: false, ...doc.data()}
      })

      for (const [index, palette] of palettesSnap.docs.entries()) {
        const likedDocSnap = await this.db
            .collection('users')
            .doc(this.user.data.uid)
            .collection('likedPalettes')
            .doc(palette.id).get()

        this.palettes[index]['isLiked'] = likedDocSnap.exists
      }

    },
    async loadMorePalettes() {
      try {
        let palettesSnap = this.db
            .collection('palettes')

        if (this.keywordValue) {
          palettesSnap = palettesSnap
              .where('colorKeywords', 'array-contains', this.keywordValue)
        }

        palettesSnap = await palettesSnap
            .orderBy('createdAt', "desc")
            .limit(12)
            .startAfter(this.lastPalette)
            .get()

        this.lastPalette = palettesSnap.docs[palettesSnap.docs.length - 1]

        const lengthBeforePushed = this.palettes.length

        palettesSnap.forEach(doc => {
          this.palettes.push({id: doc.id, ...doc.data()})
        })

        for (const [index, palette] of palettesSnap.docs.entries()) {
          const likedDocSnap = await this.db
              .collection('users')
              .doc(this.user.data.uid)
              .collection('likedPalettes')
              .doc(palette.id).get()

          this.$set(this.palettes[index + lengthBeforePushed], 'isLiked', likedDocSnap.exists)
        }

      } catch (e) {
        console.log(e.message)
      }
    },
    changeKeyword(keyword) {
      this.keywordValue = keyword
    }
  },
  watch: {
    keywordValue: {
      handler(keywordValue) {
        if (keywordValue) {
          this.fetchPalettes()
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
}
</script>